import { SvgIcon } from '@progress/kendo-react-common';
import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { lockIcon } from '@progress/kendo-svg-icons';
import moment from 'moment-timezone';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { formatPeriod } from 'src/utils/constants';
import { GLPeriodYearDropdown } from 'src/utils/transformation';

const PeriodHeadCell = (props: GridHeaderCellProps) => {
  const { dropDownYearValue } = useViewCheckbook();
  const { periods = [] } = dropDownYearValue ?? ({} as GLPeriodYearDropdown);

  const index = props.field?.substring(6);
  const finalStartDate = moment(new Date(periods[Number(index) - 1]?.startDate)).format('MM/DD');
  const finalEndDate = moment(new Date(periods[Number(index) - 1]?.endDate)).format('MM/DD');
  const value = `Period ${formatPeriod(String(index))} (${finalStartDate} - ${finalEndDate}) Amt`;
  const isLocked = periods[Number(index) - 1]?.isClosed === 1;

  return (
    <div className="k-column-title" title={value}>
      {value}
      {isLocked && <SvgIcon icon={lockIcon} className="ml-2 mb-1" />}
    </div>
  );
};
export default PeriodHeadCell;
